import React from 'react';
import {FormattedMessage} from 'react-intl';

import {GIFT_CARDS_TEXT, GIFT_CARD_TITLE, GIFT_CARD_SUBTITILE, MESSAGE, PLEASE_NOTE_TEXT, NOTE, LEARN_MORE_LINK, LEARN_MORE_TEXT, VRBO, BED_AND_BREAKFAST, GIFT_CARD_IMAGE_URL} from '../../../utils/constants';

import './GiftCardMessage.less';


const GIFT_CARDS_LABEL = (
    <FormattedMessage
        id="giftCardsText"
        defaultMessage={GIFT_CARDS_TEXT}
    />
);

const GIFT_CARD_TITLE_LABEL = (
    <FormattedMessage
        id="giftCardTitle"
        defaultMessage={GIFT_CARD_TITLE}
        values={{bnbbrandSite: BED_AND_BREAKFAST}}
    />
);

const GIFT_CARD_SUBTITILE_LABEL = (
    <FormattedMessage
        id="giftCardSubtitle"
        defaultMessage={GIFT_CARD_SUBTITILE}
        values={{bnbbrandSite: BED_AND_BREAKFAST, vrboBrandName: VRBO}}
    />
);

const MESSAGE_LABEL = (
    <FormattedMessage
        id="giftCardMessage"
        defaultMessage={MESSAGE}
        values={{bnbbrandSite: BED_AND_BREAKFAST}}
    />
);

const PLEASE_NOTE_LABEL = (
    <FormattedMessage
        id="giftCardPleaseNoteLabel"
        defaultMessage={PLEASE_NOTE_TEXT}
    />
);

const NOTE_LABEL = (
    <FormattedMessage
        id="giftCardNoteMessage"
        defaultMessage={NOTE}
    />
);

const LEARN_MORE_LABEL = (
    <FormattedMessage
        id="giftCardLearnMoreLinkText"
        defaultMessage={LEARN_MORE_TEXT}
    />
);

export default function GiftCardMessage() {
    return (<div className="GiftCardMessage">
        <div className="GiftCardMessage__Wrapper GiftCard__Max_width">
            <span className="GiftCardMessage__Banner_text">{GIFT_CARDS_LABEL}</span>
            <h2 className="GiftCardMessage__Title">{GIFT_CARD_TITLE_LABEL}</h2>
            <h3 className="GiftCardMessage__Subheading">{GIFT_CARD_SUBTITILE_LABEL}</h3>
            <div className="GiftCardMessage__Message">{MESSAGE_LABEL}</div>
            <div className="GiftCardMessage__Note">
                <span className="GiftCardMessage__Label">
                    {PLEASE_NOTE_LABEL}
                </span>
                <span>{NOTE_LABEL}</span>
                <a
                    className="GiftCardMessage__Note_Learn_More"
                    href={LEARN_MORE_LINK}
                >
                    {LEARN_MORE_LABEL}
                </a>
            </div>
        </div>
        <div className="GiftCardMessage_Image_Wrapper_Outer">
            <img className="GiftCardMessage_Image" src={GIFT_CARD_IMAGE_URL} alt="image"/>
        </div>
    </div>);
}
